export default __webpack_public_path__ + "static/media/process-diagram-fpo.0c11d2c6.png";